import React, { useContext } from "react";
import styles from "../DeleteProduct/DeleteProductModal.module.css";
import { deleteProductsFromDatabase, deleteAllProductsByStoreId } from '../../../hooks/Product';
import { ProductContext } from '../../../context/ProductContext';
import { StoresContext } from '../../../context/StoresContext';

function Modal({ closeModal }) {
  const { 
    selectedStore,
   } = useContext(StoresContext);

   const { 
    productIds,
    setIsDeletedProduct
   } = useContext(ProductContext);

  const deleteAllProducts = async () => {
    if(selectedStore != null) {
        try {
          const response = await deleteAllProductsByStoreId(selectedStore.id); 
          if (response) {
            setIsDeletedProduct(true)
            closeModal()
          } else {
            setIsDeletedProduct(false)
            console.error("Error to delete products:");
          }
      } catch (error) {
          setIsDeletedProduct(false)
          console.error("Error to delete selected products:", error);
      }
    }
  }
  
  const deleteProducts = async () => {
    if(productIds != null && productIds.length > 0) {
      try {
        const response = await deleteProductsFromDatabase( productIds ); 
        if (response) {
          setIsDeletedProduct(true)
          closeModal()
        } else {
          setIsDeletedProduct(false)
          console.error("Error to delete products:");
        }
      } catch (error) {
        setIsDeletedProduct(false)
        console.error("Error to delete selected products:", error);
      }
    }
  }

  const getDeleteMessage = () => {
    if (productIds != null && productIds.length > 0) {
      return "Deseja excluir os item(s) selecionados da loja?";
    } else if(selectedStore != null && productIds.length === 0) {
      return "Deseja excluir todos os produtos da loja?";
    }else {
        return null;
    }
  };

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <h2>{ getDeleteMessage() }</h2>
          <p>{selectedStore && `Id: ${selectedStore.id}`}</p>
          <p>{selectedStore && `Nome da loja: ${selectedStore.name}`}</p>
          <p>{selectedStore && `CNPJ: ${selectedStore.cnpj}`}</p>
          <p>{selectedStore && `Telefone: ${selectedStore.phone}`}</p>

        </div>

        <div className={styles.buttonContent}>
        <button 
          className={styles.buttonConfirm}
          onClick={() => {
            if (productIds.length >= 1) {
              deleteProducts();
            } else {
              deleteAllProducts();
            }
          }}>
          Deletar
        </button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
